// ============================================================================
// THE DAY SCREEN'S GLYPHS — every path transcribed from the V10 boards it appears on (01 Main,
// 21 PullSync, 22 NotifSheet, 23 MailSheet, 26 States). Stroke is `currentColor`: colour arrives
// as a `text-m-*` class, never a literal (the ship gate's brand audit).
// ============================================================================

const PATHS = {
  check: 'M20 6 9 17l-5-5',
  mail: 'M5 5h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z m-1 2 8 6 8-6',
  bell: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9 M10.3 21a1.94 1.94 0 0 0 3.4 0',
  cap: 'M22 10 12 5 2 10l10 5 10-5Z M6 12v5c3 2 9 2 12 0v-5',
  mic: 'M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3Z M5 11a7 7 0 0 0 14 0 M12 18v3',
  clock: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18Z M12 7v5l3 2',
  refresh: 'M21 12a9 9 0 1 1-3-6.7L21 8 M21 3v5h-5',
  sliders:
    'M4 7h10 M18 7h2 M4 17h4 M12 17h8 M16 4.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5Z M10 14.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5Z',
  close: 'M6 6l12 12M18 6 6 18',
  warn: 'M12 3l10 18H2Z M12 10v4 M12 17h.01',
} as const

export type GlyphName = keyof typeof PATHS

export function Glyph({
  name,
  size = 16,
  strokeWidth = 2,
  className,
}: {
  name: GlyphName
  size?: number
  strokeWidth?: number
  className?: string
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  )
}
